import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { from } from 'rxjs';
import { catchError, map } from "rxjs/operators";
import { environment } from '../environments/environment';
import { TokenDeviceService } from './shared/service/token/token-device.service';
import { LocalStorageService } from './shared/service/storage/storage.service';

@Injectable()
export class Interceptor implements HttpInterceptor {

  constructor(private auth: TokenDeviceService, private storage: LocalStorageService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler) {

    // convert promise to observable using 'from' operator
    if (req.url.indexOf(".json") != -1) {
      return next.handle(req);
    }

    return from(this.handle(req, next))
      .pipe(catchError((error) => {
        if (error instanceof HttpErrorResponse && (error.status === 401 || (error.status === 403 && req.url.endsWith(environment.carontePix.charonId)))) {
          return this.handle401Error(req, next);
        }
        throw error;
      }))
      .pipe(map<HttpEvent<any>, any>((evt: HttpEvent<any>) => {
        return evt;
      }));
  }

  private handle401Error(request: HttpRequest<any>, next: HttpHandler) {
    this.storage.remove('token');
    return next.handle(request);
  }

  private async handle(req: HttpRequest<any>, next: HttpHandler) {
    let authToken = await this.auth.getToken();

    const authReq = req.clone({
      setHeaders: {
        Authorization: 'Bearer ' + authToken
      }
    });

    return await next.handle(authReq).toPromise();
  }
}
